import React from "react";
import ReactDOM from "react-dom";
import Favicon from 'react-favicon'
import favicon from './favicon/favicon.ico'
import CartProvider from "./components/cart/CartContext.jsx";
import App from "./App.js";

ReactDOM.render(
	<React.StrictMode>
		<CartProvider>
			<App />
			<Favicon url={favicon} />
		</CartProvider>
	</React.StrictMode>,
	document.getElementById("root")
);